//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const Page = require('./Page.vue').default

module.exports = {
  props: {
    page: {
      type: Number,
      default: 1
    },
    pages: {
      type: Number
    },
    width: {
      type: Number,
      default: 7
    },
    pageFn: {
      type: Function
    }
  },
  methods: {
    onClick: function (page) {
      this.$emit('change', page)
    }
  },
  components: { page: Page }
}



// WEBPACK FOOTER //
// ./src/plugins/vue-bootstrap-paginator/src/components/Pagination.vue